import React, {Component} from 'react';
import {View, Text, Dimensions} from 'react-native';
import {Icon, AntIcon} from '../icons';

export const Footer = props => {
  return (
    <View
      style={{
        height: Dimensions.get('screen').width > 720 ? 50 : 70,
        backgroundColor: 'white',
        flexDirection: Dimensions.get('screen').width > 720 ? 'row' : 'column',
        justifyContent: 'space-around',
        width: '90%',
        alignSelf: 'center',
      }}>
      <Text style={{alignSelf: 'center'}}>2020 © Mridul Baishya </Text>
      {Dimensions.get('screen').width > 720 ? null : (
        <View style={{height: 10}} />
      )}
      <View
        style={{
          justifyContent:
            Dimensions.get('screen').width > 720 ? 'flex-end' : 'center',
          flexDirection: 'row',
          flex: 1,
          alignSelf: 'center',
        }}>
        <SocialIcon name="github" size={24} color="black" />
        <View style={{width: 20}} />
        <SocialIcon name="twitter" size={24} color="black" />
        <View style={{width: 20}} />
        <SocialIcon name="instagram" size={24} color="black" />
        <View style={{width: 20}} />
        <SocialIcon name="facebook-square" size={24} color="black" />
        <View style={{width: 20}} />
        <SocialIcon name="codepen" size={24} color="black" />
      </View>
    </View>
  );
};

const SocialIcon = props => {
  return <AntIcon name={props.name} size={props.size} color={props.color} />;
};
